// extracted by mini-css-extract-plugin
module.exports = {"header":"_48ee32a9","title":"_e2089156","browseLink":"_b6ea9268","text":"_d4b03aeb","arrowIcon":"_4dcc4ee4"};